<!-- BASE LAYOUT NAVBAR -->
<app-base-topbar></app-base-topbar>

<!-- BASE LAYOUT BODY -->
<app-root></app-root>

<!-- BASE LAYOUT FOOTER -->
<app-base-footer></app-base-footer>
